import { Link } from "react-router-dom";
import loading from "../../../assets/images/loading.gif"
import { useState, useEffect } from "react";
import Pagination from "../../../components/Pagination";
import { useSelector } from "react-redux";
import { makeGetRequest } from "../../../request";
import { ToastContainer, toast } from 'react-toastify';

import { formatDateTime } from "../../../helpers";
import Layout from "../../Layout";
import { ConsolidatedDocumentInfo } from "interfaces/consolidateddocuments.types";

const ConsolidatedDocuments =  () => {
    const user: any = useSelector((state: any)=> state.tepngUser.value)
    const [packinglists, setRecords] = useState<ConsolidatedDocumentInfo[]>([])
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const [startIndex, setStartIndex] = useState(0);
    const getPageNumbers = () => {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
            if (currentPage >= startIndex + 4) {
                setStartIndex(startIndex + 4);
            }
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            if (currentPage - 1 <= startIndex) {
                setStartIndex(startIndex - 4);
            }
        }
    };
    
    const [searchValue, setSearchValue] = useState("")
    const handleSearch = (event: any) => {
        const value = event.target.value
        if(!value) setSearchValue("")
    }

    const [isLoading, setIsLoading] = useState(false)
    const getConsolidatedDocuments = () => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: "getShippingDocuments",
            params: {
                page: currentPage,
                pageSize: itemsPerPage,
                userId: user?.id
            }
        };
        if(searchValue) {request.params.SearchString = searchValue;}
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                const res = response.data
                setRecords(res.data)
                setTotalItems(res.totalCount)
            })
            .catch((error:any) => 
                {toast.error(error); setIsLoading(false)}
            );
    }

    const row = packinglists.map((data, index) => {
                    return (
                        <tr key={index}>
                            <td>{ currentPage === 1 ? currentPage + index : (((itemsPerPage*currentPage)-itemsPerPage)+1) + index }</td>
                            <td>{ data.consolidatedCommercialInvoice.invoiceNumber }</td>
                            <td>{ data.consolidatedPackingList.packingListNumber }</td>
                            <td>{ formatDateTime(data.createdDate) }</td>
                            <td>{ data.consolidatedCommercialInvoice?.modeOfShipping }</td>
                            <td>{ data?.consolidatedCommercialInvoice?.purchaseOrderItemSupplies[0]?.currency }</td>
                            <td>{ data?.consolidatedCommercialInvoice?.consignee }</td>
                            <td>{ data?.consolidatedCommercialInvoice?.destinationPlant }</td>
                            <td>                                                        
                                <Link to={"/freightforwarder/consolidateddocument/"+data.id} className="actions">
                                    <span className="material-symbols-rounded">pageview</span>
                                    <span>View Documents</span>
                                </Link>
                            </td>
                        </tr>
                    )
                })

    useEffect(() => {
        getConsolidatedDocuments() // eslint-disable-next-line
    }, [user, currentPage, itemsPerPage, searchValue])

    const page = "Consolidated Documents"

    return (
        <Layout title={page}>
            <div className="container">
                <div className="main">
                    <h3 className="page_title">{  }</h3>     
                    <div className="main-inner">
                        <div className="main-inner-top">
                            <div className="d-flex">
                                <div className="search-container left-item">
                                    <span className="material-symbols-rounded">search</span>
                                    <input id="search" placeholder="Search Documents" onKeyUp={handleSearch}  />
                                </div>
                                <button className="custom-button orange left-item ml-2"
                                    onClick={() => {setSearchValue((document.getElementById("search") as HTMLInputElement)?.value); setCurrentPage(1)}}
                                >Search</button>
                            </div>
                            <Link to={"/freightforwarder/create/consolidateddocument"} style={{ textDecoration: "none" }}>
                                <button className="custom-button orange">
                                    <span className="material-symbols-rounded fw-600">add</span>Create Consolidated Documents
                                </button>
                            </Link>
                        </div>                        

                        <div className='table-container custom'>
                            <table>
                                <thead>
                                    <tr className="no-textwrap">
                                        <th>SN</th>
                                        <th>Commercial Invoice N<sup>o</sup></th>
                                        <th>Packing List N<sup>o</sup></th>
                                        <th>Created Date</th>
                                        <th>Shipping Mode</th>
                                        <th>Currency</th>
                                        <th>Consignee</th>
                                        <th>Destination Plant</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {isLoading ? null : (
                                        packinglists?.length === 0 ? <td className='no-records' colSpan={6}>No Records Found</td>
                                        : row
                                    )
                                }
                                </tbody>
                            </table>
                            {isLoading ? <div className="loader">
                                        <img src={loading} alt="loading" />
                                        <p>Loading data...</p>
                                    </div> : null}
                        </div>
                        <div className="pagination-container">
                        <Pagination
                                currentPage={currentPage}
                                itemsPerPage={itemsPerPage}
                            totalPages={totalPages}
                            handlePrevious={handlePrevious}
                            handleNext={handleNext}
                            setCurrentPage={setCurrentPage}
                            getPageNumbers={getPageNumbers}
                            setItemsPerPage={setItemsPerPage}
                            startIndex={startIndex} />
                        </div> 
                    </div>                 
                </div>
                <ToastContainer />
            </div>
        </Layout>
    )
}

export default ConsolidatedDocuments